"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const tf = __importStar(require("@tensorflow/tfjs"));
const vega_embed_1 = __importDefault(require("vega-embed"));
const utils_1 = require("../util/utils");
const render_utils_1 = require("./render_utils");
function heatmap(container, data, opts = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const options = Object.assign({}, defaultOpts, opts);
        const drawArea = render_utils_1.getDrawArea(container);
        let inputValues = data.values;
        if (options.rowMajor) {
            let originalShape;
            let transposed;
            if (inputValues instanceof tf.Tensor) {
                originalShape = inputValues.shape;
                transposed = inputValues.transpose();
            }
            else {
                originalShape = [inputValues.length, inputValues[0].length];
                transposed =
                    tf.tidy(() => tf.tensor2d(inputValues).transpose());
            }
            utils_1.assert(transposed.rank === 2, 'Input to renderHeatmap must be a 2d array or Tensor2d');
            inputValues = yield transposed.array();
            transposed.dispose();
            const transposedShape = [inputValues.length, inputValues[0].length];
            utils_1.assert(originalShape[0] === transposedShape[1] &&
                originalShape[1] === transposedShape[0], `Unexpected transposed shape. Original ${originalShape} : Transposed ${transposedShape}`);
        }
        const values = [];
        const { xTickLabels, yTickLabels } = data;
        if (inputValues instanceof tf.Tensor) {
            utils_1.assert(inputValues.rank === 2, 'Input to renderHeatmap must be a 2d array or Tensor2d');
            const shape = inputValues.shape;
            if (xTickLabels) {
                utils_1.assert(shape[0] === xTickLabels.length, `Length of xTickLabels (${xTickLabels.length}) must match number of rows
          (${shape[0]})`);
            }
            if (yTickLabels) {
                utils_1.assert(shape[1] === yTickLabels.length, `Length of yTickLabels (${yTickLabels.length}) must match number of columns
          (${shape[1]})`);
            }
            const inputArray = yield inputValues.data();
            const [numRows, numCols] = shape;
            for (let row = 0; row < numRows; row++) {
                const x = xTickLabels ? xTickLabels[row] : row;
                for (let col = 0; col < numCols; col++) {
                    const y = yTickLabels ? yTickLabels[col] : col;
                    const index = (row * numCols) + col;
                    const value = inputArray[index];
                    values.push({ x, y, value });
                }
            }
        }
        else {
            if (xTickLabels) {
                utils_1.assert(inputValues.length === xTickLabels.length, `Number of rows (${inputValues.length}) must match
          number of xTickLabels (${xTickLabels.length})`);
            }
            const inputArray = inputValues;
            for (let row = 0; row < inputArray.length; row++) {
                const x = xTickLabels ? xTickLabels[row] : row;
                if (yTickLabels) {
                    utils_1.assert(inputValues[row].length === yTickLabels.length, `Number of columns in row ${row} (${inputValues[row].length})
            must match length of yTickLabels (${yTickLabels.length})`);
                }
                for (let col = 0; col < inputArray[row].length; col++) {
                    const y = yTickLabels ? yTickLabels[col] : col;
                    const value = inputArray[row][col];
                    values.push({ x, y, value });
                }
            }
        }
        const embedOpts = {
            actions: false,
            mode: 'vega-lite',
            defaultStyle: false,
        };
        const spec = {
            'width': options.width || drawArea.clientWidth,
            'height': options.height || drawArea.clientHeight,
            'padding': 0,
            'autosize': {
                'type': 'fit',
                'contains': 'padding',
                'resize': true,
            },
            'config': {
                'axis': {
                    'labelFontSize': options.fontSize,
                    'titleFontSize': options.fontSize,
                },
                'text': { 'fontSize': options.fontSize },
                'legend': {
                    'labelFontSize': options.fontSize,
                    'titleFontSize': options.fontSize,
                },
                'scale': { 'bandPaddingInner': 0, 'bandPaddingOuter': 0 },
            },
            'data': { 'values': values },
            'mark': 'rect',
            'encoding': {
                'x': {
                    'field': 'x',
                    'type': options.xType,
                    'scale': { 'domain': xTickLabels },
                    'title': options.xLabel,
                },
                'y': {
                    'field': 'y',
                    'type': options.yType,
                    'scale': { 'domain': yTickLabels },
                    'title': options.yLabel,
                },
                'fill': {
                    'field': 'value',
                    'type': 'quantitative',
                },
            }
        };
        let colorRange;
        switch (options.colorMap) {
            case 'blues':
                colorRange = ['#f7fbff', '#4292c6'];
                break;
            case 'greyscale':
                colorRange = ['#000000', '#ffffff'];
                break;
            case 'viridis':
            default:
                colorRange = 'viridis';
                break;
        }
        if (colorRange !== 'viridis') {
            const fill = spec.encoding.fill;
            fill.scale = { 'range': colorRange };
        }
        if (options.domain) {
            const fill = spec.encoding.fill;
            if (fill.scale != null) {
                fill.scale = Object.assign({}, fill.scale, { 'domain': options.domain });
            }
            else {
                fill.scale = { 'domain': options.domain };
            }
        }
        yield vega_embed_1.default(drawArea, spec, embedOpts);
    });
}
exports.heatmap = heatmap;
const defaultOpts = {
    xLabel: null,
    yLabel: null,
    xType: 'ordinal',
    yType: 'ordinal',
    colorMap: 'viridis',
    fontSize: 12,
    domain: null,
    rowMajor: false,
};
//# sourceMappingURL=heatmap.js.map